import { WatcherFunction } from '..'
import { watchFetchInfluencerIdentitiesRequest } from './influencerIdentities'
import { watchFetchInfluencerIdentitiesUsingNextRequest } from './influencerIdentitiesUsingNext'

export const influencerIdentitiesSaga: ReadonlyArray<WatcherFunction> = [
  watchFetchInfluencerIdentitiesRequest,
  watchFetchInfluencerIdentitiesUsingNextRequest,
]
